import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { MaterialsCheck } from "@/components/planning/MaterialsCheck";

export const BatchMaterialsCheck = ({ product, quantity, sizes = [] }) => {
  const body = { ...(product?.from_sheet ? { sheet_id: product.sheet_id, color: product.color } : { product_id: product?.id, color: product?.color }), quantity, sizes };
  const { data } = useQuery({ queryKey: ["batch-check", JSON.stringify(body)], enabled: !!product && quantity > 0, queryFn: async () => (await api.post("/production/check-materials", body)).data, placeholderData: (p) => p });
  if (!product || !quantity || !data?.sheet) return null;
  const rows = [...data.fabrics, ...data.accessories];
  const missing = rows.filter((r) => r.missing_now > 0);
  return (
    <div className="space-y-2 rounded-md border border-border/60 p-3" data-testid="batch-materials-check">
      <p className={`flex items-center gap-1.5 text-xs font-semibold ${missing.length ? "text-rose-400" : "text-emerald-400"}`} data-testid="batch-materials-status">
        {missing.length ? <AlertTriangle className="h-3.5 w-3.5" /> : <CheckCircle2 className="h-3.5 w-3.5" />}
        {missing.length ? `Materiale non sufficiente per ${missing.length} ${missing.length === 1 ? "voce" : "voci"}: controlla cosa ordinare` : "Materiale disponibile in magazzino"}
      </p>
      <p className="text-[11px] text-muted-foreground">Calcolato dalla distinta base {data.sheet.name} (consumi per capo e materiali del colore).</p>
      {rows.length > 0 && <MaterialsCheck res={data} />}
    </div>
  );
};
